export const enum WalmartLandingState {
  LOGGED_OUT = 'logged-out',
  UNLINKED = 'unlinked',
  LINKED = 'linked',
}

export const getWalmartLandingState = (
  isAuthenticated: boolean,
  isWalmartLinked: boolean
): WalmartLandingState => {
  if (!isAuthenticated) {
    return WalmartLandingState.LOGGED_OUT;
  }
  return isWalmartLinked ? WalmartLandingState.LINKED : WalmartLandingState.UNLINKED;
};
